import React from 'react';
import PropTypes from 'prop-types';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material';
import StaticStepIcon from '../step-icons/StaticStepIcon';
import DynamicStepIcon from '../step-icons/DynamicStepIcon';

const FingoStepLabel = ({
  title,
  description,
  staticMode,
  iconSize,
}) => {
  const theme = useTheme();
  const muiStepLabelIconContainerActiveStyle = {
    borderColor: theme.palette.neutral.A500,
    backgroundColor: 'transparent',
    '&.Mui-active': {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.main,
    },
    '&.Mui-completed': {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.A100,
    },
  };
  const muiStepLabelIconContainerStaticStyle = {
    borderColor: theme.palette.primary.A700,
    backgroundColor: theme.palette.common.white,
  };
  const muiStepLabelActiveStyle = {
    cursor: 'pointer',
    '&.Mui-active': {
      color: theme.palette.neutral.A700,
      '& > :first-of-type': {
        color: theme.palette.primary.main,
      },
    },
    '&.Mui-completed': {
      color: 'black',
    },
  };
  const muiStepLabelLabelStaticStyle = {
    color: theme.palette.common.white,
  };

  const getStepIconComponent = () => {
    if (staticMode) {
      return (props) => <StaticStepIcon {...props} iconSize={iconSize} />;
    }
    return (props) => <DynamicStepIcon {...props} iconSize={iconSize} />;
  };
  return (
    <StepLabel
      StepIconComponent={getStepIconComponent()}
      sx={{
        gap: '1rem',
        py: 0,
        flexDirection: 'row',
        '& .MuiStepLabel-iconContainer': {
          p: 0,
          borderRadius: '50%',
          width: iconSize,
          height: iconSize,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '2.7px solid',
          ...(!staticMode
            ? { ...muiStepLabelIconContainerActiveStyle }
            : muiStepLabelIconContainerStaticStyle),
        },
        '& .MuiStepLabel-label': {
          display: 'flex',
          flexDirection: 'column',
          color: theme.palette.neutral.A500,
          ...(!staticMode
            ? { ...muiStepLabelActiveStyle }
            : muiStepLabelLabelStaticStyle),
        },
      }}
    >
      <Typography
        variant="small_2"
        fontWeight={700}
        fontSize={{ xs: '1rem', lg: '1.2rem' }}
        color={staticMode ? theme.palette.common.white : theme.palette.neutral.A700}
      >
        {title}
      </Typography>
      {description && (
        <Typography
          variant="small_1"
          textAlign={{ desktop: 'center', lg: 'left' }}
        >
          {description}
        </Typography>
      )}
    </StepLabel>
  );
};

FingoStepLabel.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  staticMode: PropTypes.bool.isRequired,
  iconSize: PropTypes.string,
};

FingoStepLabel.defaultProps = {
  description: null,
  iconSize: '45px',
};

export default FingoStepLabel;
